import React, { useMemo } from "react";
import ContextMenu from "../../Components/Utils/ContextMenu/ContextMenu";
import { ContextMenuItem } from "../../Types/ContextMenuItem";
import styles from "./Library.module.css";

type FileMenuProps = {
  fileId: string;
  title: string;
  onMove: (id: string, title: string) => void;
};

const FileMenu = ({ fileId, title, onMove }: FileMenuProps) => {
  const items: ContextMenuItem[] = useMemo(() => [
    {
      title: "Move",
      icon: "/img/change.svg",
      onClickHandler: () => onMove(fileId, title),
    },
  ], [fileId, title, onMove]);

  return (
    <ContextMenu items={items} contextId={fileId} position="left">
      <button type="button" className={styles.iconButton} aria-label={`File actions for ${title}`}>
        <img src="/img/menu-meatballs.svg" alt="" />
      </button>
    </ContextMenu>
  );
};

export default FileMenu;
